import React from "react";
import { useLocation } from "react-router-dom";
import { useLayout } from "../../hooks/useLayout";

const SkipToContent = () => {
  const { translations } = useLayout();
  return (
    <div className="skip-to-content">
      <ul>
        <li>
          <a className="skip-link" href={`${useLocation().pathname}#maincontent`} tabIndex={1}>
            {translations.skipToContent}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SkipToContent;
